import { render, staticRenderFns } from "./Nav-Bar.vue?vue&type=template&id=647a1908&scoped=true&"
import script from "./Nav-Bar.vue?vue&type=script&lang=js&"
export * from "./Nav-Bar.vue?vue&type=script&lang=js&"
import style0 from "./Nav-Bar.vue?vue&type=style&index=0&id=647a1908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a1908",
  null
  
)

export default component.exports